import { toast } from 'react-toastify';

import { axios } from './axios';
import { Option } from '../pages/types';
import { BOTTOM_TOAST, generateErrorMsg, PET_PLAN_HOLD_STATUS_ERROR } from '../utils';

interface UpdatePetStatusData {
  petId: string;
  petStatus: string;
  customerId: string;
}

export const createPetAndPetPlan = (petData: any, petPlan: any, startDate: any) => {
  const {
    dogName,
    weight,
    isNeuteredOrSpayed,
    selectedMonth,
    selectedYear,
    selectedBodyType,
    selectedLifestyle,
    customerId,
    selectedGender,
    selectedBreeds,
    planSizeId,
    selectedHealthConditions,
  } = petData;
  axios
    .post(`pet_plans/create_pet_and_pet_plan`, {
      pet: {
        name: dogName,
        birth_year: selectedYear,
        breeds: selectedBreeds,
        weight,
        gender: selectedGender,
        neutered: isNeuteredOrSpayed,
        birth_month: selectedMonth,
        recommended_calories_day: planSizeId,
        body_type: selectedBodyType,
        lifestyle: selectedLifestyle,
        health_conditions: selectedHealthConditions,
        account: customerId,
      },
      pet_plan: {
        product: petPlan?.subscription?.product?.code,
        frequency: petPlan?.subscription?.product?.frequency,
        unit_price: petPlan?.subscription?.price?.price,
        plan_size: planSizeId,
        quantity: 1,
        start_date: startDate,
      },
      account_id: customerId,
    })
    .then(() => {
      toast.success('Pet created successfully', BOTTOM_TOAST);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    })
    .catch((e) => {
      toast.error(generateErrorMsg(e), BOTTOM_TOAST);
    });
};

export const updatePet = (petData: any) => {
  const {
    petId,
    dogName,
    weight,
    isNeuteredOrSpayed,
    selectedMonth,
    selectedYear,
    selectedBodyType,
    selectedLifestyle,
    selectedHealthConditions,
    customerId,
    recommended_calories_day,
    breeds,
    gender,
  } = petData;
  axios
    .put(`pets/${petId}`, {
      name: dogName,
      birth_year: selectedYear,
      weight,
      neutered: isNeuteredOrSpayed,
      recommended_calories_day,
      birth_month: selectedMonth,
      body_type: selectedBodyType,
      lifestyle: selectedLifestyle,
      health_conditions: selectedHealthConditions,
      account: customerId,
      breeds,
      gender,
    })
    .then((response) => {
      window.location.reload();
    })
    .catch((e) => {
      toast.error(generateErrorMsg(e), BOTTOM_TOAST);
    });
};

export const updatePetAndPetPlan = (petData: any) => {
  const {
    petId,
    dogName,
    weight,
    isNeuteredOrSpayed,
    selectedMonth,
    selectedYear,
    selectedBodyType,
    selectedLifestyle,
    selectedHealthConditions,
    customerId,
    recommended_calories_day,
    productCode,
    price,
    frequency,
    petPlanId,
    mealPlanProductId,
    breeds,
    gender,
  } = petData;
  axios
    .put(`pets/${petId}`, {
      name: dogName,
      birth_year: selectedYear,
      weight,
      neutered: isNeuteredOrSpayed,
      recommended_calories_day,
      birth_month: selectedMonth,
      body_type: selectedBodyType,
      lifestyle: selectedLifestyle,
      health_conditions: selectedHealthConditions,
      account: customerId,
      breeds,
      gender,
    })
    .then(() => {
      axios
        .put(`pet_plans/${petPlanId}`, {
          account: customerId,
          unit_price: price,
          product: productCode,
          frequency,
          quantity: 1,
          plan_size: recommended_calories_day,
          pet_plan_id: petPlanId,
          pet_plan_product_id: mealPlanProductId,
        })
        .then(() => {
          window.location.reload();
        })
        .catch((e) => {
          if (e.response?.status === 403 && e.response?.data === PET_PLAN_HOLD_STATUS_ERROR) {
            toast.error(
              'Payment Method Update Required. Please update your payment method. We are unable to make changes to your pup’s plan due to a payment issue with their most recent order. Please update your payment method before making changes to future orders.',
              BOTTOM_TOAST
            );
          } else {
            toast.error(generateErrorMsg(e), BOTTOM_TOAST);
          }
        });
    })
    .catch((e) => {
      toast.error(generateErrorMsg(e), BOTTOM_TOAST);
    });
};

export const cancelPetPlan = (petData: any) => {
  const {
    petId,
    petStatus,
    accountId,
    surveyTag,
    petPlanProduct,
    productCode,
    petPlanProductCreatedAt,
    unitPrice,
    primaryCancellationReason,
    secondaryCancellationReason,
    cancellationReasonComments,
    petPlan,
  } = petData;
  const response = axios.post(`/pets/${petId}/cancel`, {
    is_bark: true,
    account_id: accountId,
    pet_status: petStatus,
    survey_tag: surveyTag,
    pet_plan_product: petPlanProduct,
    product_code: productCode,
    pet_plan_product_created_at: petPlanProductCreatedAt,
    unit_price: unitPrice,
    primary_answer: primaryCancellationReason,
    secondary_answer: secondaryCancellationReason,
    customer_comments: cancellationReasonComments,
    pet_plan: petPlan,
  });

  return response;
};

export const updatePetStatus = (updatePetStatusData: UpdatePetStatusData) => {
  const { petId, petStatus, customerId } = updatePetStatusData;
  const response = axios.put(`/pets/${petId}`, {
    status: petStatus,
    account: customerId,
  });
  return response;
};

export const sortPetBreeds = (unsortedBreedList: Option[]) => {
  const MIXED_BREED_NAME = 'Mixed Breed';
  const mixedBreed = unsortedBreedList.find((breed) => breed.label === MIXED_BREED_NAME);

  const sortedBreedList = unsortedBreedList
    .sort((a, b) => a.label.localeCompare(b.label))
    .filter((breed) => breed.label !== MIXED_BREED_NAME);

  return mixedBreed ? [mixedBreed].concat(sortedBreedList) : sortedBreedList;
};
